// src/services/country.service.ts
import api from './api';

// Get country dropdown (public)
export const getCountryDropdown = async (countryId: string = "") => {
  const response = await api.post("/country/getAll", {
    CountryID: countryId,
  });
  return response.data.data; // array of { ID, CountryName, ... }
};